import React from 'react';

import Ribbon from './ribbon';
import Image from '../Image/Image';
import Currency from '../../../helpers/currency';
import { InternalLink } from '../form-elements/Link';
import TireInformationModal from '../Tires/TireInformationModal';
import TireEnergyLabelLinks from '../../routes/Tires/TireEnergyLabelLinks';
import { useSelector } from 'react-redux';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import _ from 'lodash';
import classnames from 'classnames';

function ProductListRow({ product }) {
    const to = product.href || `/${_.first(product.categories)}/${product.slug || product.id}`
    const markenStandort = useSelector(markenStandortSelector)
    const isNoa = markenStandort.gesellschafterNr === "035";
    const isTechno = markenStandort.isTechno;
    let image;

    if ((product.imagelink).includes('techno-images.s3.eu-central-1.amazonaws.com')) {
        image = product.imagelink.replace(/%20| /g, '+');
    } else if ((product.imagelink).includes('technoshopautohaus.blob.core.windows.net') && !(product.imagelink).includes('.jpg') && !(product.imagelink).includes('.png')) {
        let image_url = product.imagelink.replace('https://technoshopautohaus.blob.core.windows.net', 'https://techno-images.s3.eu-central-1.amazonaws.com');
        image = `${image_url}.jpg`;
    } else if ((product.imagelink).includes('technoshopautohaus.blob.core.windows.net') && (product.imagelink).includes('.jpg')) {
        image = product.imagelink.replace('https://technoshopautohaus.blob.core.windows.net', 'https://techno-images.s3.eu-central-1.amazonaws.com');
    } else if ((product.imagelink).includes('technoshopautohaus.blob.core.windows.net') && (product.imagelink).includes('.png')) {
        image = product.imagelink.replace('https://technoshopautohaus.blob.core.windows.net', 'https://techno-images.s3.eu-central-1.amazonaws.com');
    } else {
        image = product.imagelink;
    }

    let isOfferActive = product.isDeliveryOfferActive || product.isPickUpOfferActive;

    return (
        <>
            <div className="uk-grid uk-grid-small" data-uk-grid="">
                <div className="uk-width-1-4@m uk-width-1-1" style={{ minWidth: 220 }}>
                    <InternalLink to={to} modifier="reset">
                        <div className="uk-flex uk-flex-center uk-position-relative">
                            <div>
                                <Ribbon product={product} isOfferActive={isOfferActive} />
                                <div className="uk-flex uk-flex-middle" style={{ height: 235 }}>
                                    <Image style={{ maxHeight: 235 }} src={image} alt={product.imageAlt || 'Produktbild'} resizeHeight={235} />
                                </div>
                            </div>
                        </div>
                    </InternalLink>
                </div>
                <div className="uk-width-expand">
                    <InternalLink to={to} modifier="reset">
                        <h2 className="uk-margin-remove-top">
                            <div dangerouslySetInnerHTML={{ __html: product.bezeichnung }} aria-label={`Zum Produkt: ${product.bezeichnung.replace(/<[^>]*>/g, '')}`} />
                            <span>{product.shownId}</span>
                        </h2>
                    </InternalLink>
                    <div dangerouslySetInnerHTML={{ __html: product.marketingText }} />
                    {product.articleType === 'reifen' &&
                        <div className="uk-margin-small-bottom">
                            <TireInformationModal tire={product} />
                        </div>
                    }
                </div>
                <div className="uk-width-1-4@m uk-width-1-1 uk-text-center">
                    <div className="uk-margin-auto-top uk-text-center">
                        <InternalLink to={to} modifier="reset">
                            {!_.isNil(product.preisAb) ? (
                                product.originalPrice && product.originalPrice !== product.preisAb && product.promotion !== 'none' && isOfferActive ? (
                                    <div className={classnames('promotionalPriceBox_overview', { 'noaPrice': isNoa })}>
                                        <div className="oldPrice">
                                            {product.preisAb !== product.preisBis ? <span>ab </span> : <span>statt </span>}
                                            <span className="originalPrice" aria-label="ursprünglicher Preis"><Currency quantity={product.originalPrice} /></span>
                                        </div>
                                        <div className="newPrice">
                                            {!isNoa && <span className="percentage" aria-label='rabattierter Artikel'>%</span>}<Currency quantity={product.preisAb} />*
                                        </div>
                                    </div>
                                ) : (
                                    <div className='price_overview'>
                                        {product.preisAb !== product.preisBis && <span className='ab'>ab </span>}
                                        <span className={classnames({ 'noaPrice': isNoa })}><Currency quantity={product.originalPrice ? product.originalPrice : product.preisAb} />*</span>
                                    </div>
                                )

                            ) : (
                                isTechno && (
                                    <div className="uk-tile uk-tile-muted uk-padding-small">
                                        <p className="uk-text-danger uk-text-small" style={{ fontSize: '1em' }}>
                                            Finden Sie das Produkt bei einem Händler in Ihrer Nähe.
                                        </p>
                                    </div>
                                )
                            )}
                        </InternalLink>
                        <div data-uk-grid="" className="uk-grid-small uk-child-width-1-1">
                            <div>
                                <InternalLink to={to} fullWidth modifier="primary" className={product.soldOut ? "soldout-theme" : ""} ariaLabel={`Zum Produkt: ${product.bezeichnung.replace(/<[^>]*>/g, '')}${!_.isNil(product.preisAb) ? '' : ' (Finden Sie das Produkt bei einem Händler in Ihrer Nähe)'}`}>
                                    ZUM PRODUKT
                                </InternalLink>
                            </div>
                            {product.articleType === 'reifen' && <TireEnergyLabelLinks tire={product} />}
                        </div>
                    </div>
                </div>
            </div>
            <hr />
        </>
    );
}

export default ProductListRow;
